export default {"src":"https://cdn.sa-tech.de/homeone/main/_next/static/media/logo-bartolini.2ad6fb5d.svg","height":34,"width":68,"blurWidth":0,"blurHeight":0};